import { AuthGuard } from '../auth/AuthGuard';
import { ClientLayout } from './ClientLayout';

export function AuthLayout() {
  return (
    <AuthGuard>
      <ClientLayout />
    </AuthGuard>
  );
}
